export const buttonStyles = {
    base: {
        padding: "6px 14px",
        border: "none",
        borderRadius: "5px",
        transition: "all 0.2s ease"
    },

    editarActivo: {
        background: "#E5E7EB",
        color: "#0A0A0A",
        cursor: "pointer"
    },

    editarInactivo: {
        background: "#e5e7eb",
        color: "#0A0A0A",
        cursor: "not-allowed"
    },

    desactivar: {
        background: "#E5E7EB",
        color: "#0A0A0A",
        cursor: "pointer"
    },

    activar: {
        background: "#E5E7EB",
        color: "#0A0A0A",
        cursor: "pointer"
    },

    paginacion: {
        base: {
            margin: "0 5px",
            padding: "6px 12px",
            border: "1px solid #219ebc",
            borderRadius: "5px",
            cursor: "pointer",
            transition: "all 0.2s ease"
        },
        activo: {
            background: "#219ebc",
            color: "#fff"
        },
        inactivo: {
            background: "#fff",
            color: "#219ebc"
        }
    },

    buscador: {
        flex: 1,
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        marginRight: "10px"
    },

    nuevo: {
        padding: "10px 20px",
        background: "#219ebc",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "600",
        whiteSpace: "nowrap",
        transition: "all 0.2s ease"
    },

    descargar: {
        padding: "10px 20px",
        background: "#023047",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "600",
        whiteSpace: "nowrap",
        transition: "all 0.2s ease"
    }
};
